module.exports = __webpack_public_path__ + "static/media/blazer.b8eff90a.svg";